import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withStyles } from "material-ui/styles";
import Table, { TableBody, TableCell, TableRow } from "material-ui/Table";
import Button from "material-ui/Button";
import { FormControlLabel } from "material-ui/Form";
import Switch from "material-ui/Switch";
import SectionHead from "../../common/SectionHead";
import ArrowToolTip from "../../common/ArrowToolTip";
import OwnerShipLabel from "../../common/OwnerShip/OwnerShipLabel";
import ChangePasswordDialog from "./ChangePasswordDialog";
import ChangeSecurityQuestionDialog from "./ChangeSecurityQuestionDialog";
import EditEntryDialog from "./EditEntryDialog";
import EditSenderDialog from "./EditSenderDialog";
import DeleteAccountDialog from "./DeleteAccountDialog";
import ConfirmDeleteDialog from "./ConfirmDeleteDialog";
import EditOrderContactDialog from "./EditOrderContactDialog";
import EditMailDialog from "./EditMailDialog";
import EditMailsDialog from "./EditMailsDialog";
import EditAuthorityDialog from './../dialogs/EditAuthorityDialog';
import ChildAccountConfirmDialog from './../dialogs/ChildAccountConfirmDialog';
import Typography from "material-ui/Typography";
import CheckCircle from "../../Icons/CheckCircle";
import CancelCircle from "../../Icons/CancelCircle";
import HelpIcon from "../../Icons/HelpIcon";
import Exclamation from "../../Icons/Exclamation";
import Trash from "../../Icons/Trash";
import Loader from '../../Parts/Loader';

import { TagValidStatus, DialogType, ChildAccountLetterOrderAuthorityValue, ChildAccountTimelineAuthorityValue, ChildAccountAuthorityValue, ChildAccountDownloadHistoryAuthorityValue } from "../../../constants/ComponentTypes";
import { formatNameWithPosition, formatPostcode } from "../../../utils/utils";
import { isEnabledSendLetter, isEnabledExportExecutiveList, hasEverBeenEnabledExportPlan } from '../../../utils/planUtils';
import { isKLFollowCall } from "../../../utils/userUtils";

const styles = () => ({
  container: {
    width: "100%",
  },

  sectionHeader: {
    padding: "15px 56px 15px 10px",
  },

  sectionHeaderInner: {
    display: "flex",
    alignItems: "center",
  },

  table: {
    width: "100%",
  },

  tableCell: {
    fontSize: "15px",
    padding: "30px 56px 30px 10px",
  },

  firstCol: {
    width: "30%",
  },

  secondCol: {
    width: "60%",
  },

  thirdCol: {
    width: "10%",
  },

  mailFirstCol: {
    width: "40%",
  },

  mailSecondCol: {
    width: "50%",
  },

  mailThirdCol: {
    width: "10%",
  },

  button: {
    border: "1px solid #D8DBDF",
    fontSize: "15px",
    minWidth: "54px",
    color: "#181819",
    padding: "10px 15px",
  },

  buttonDelete: {
    border: "1px solid #F03A47",
    color: "#F03A47",
  },

  rightAlign: {
    float: "right",
  },

  sendersContainer: {
    padding: "20px 0px 30px 0px",
    boxSizing: "border-box",
    width: "100%",
  },

  row: {
    display: "flex",
    alignItems: "center",
    margin: "0px 10px",
  },

  lineCount: {
    background: "#F4F6F9",
    color: "#B1B3B9",
    borderRight: "1px solid #D8DBDF",
    padding: "10px",
  },

  snippet: {
    background: "white",
    border: "1px solid #D8DBDF",
    color: "#181819",
    margin: "30px 10px 20px 10px",
    display: "flex",
    alignItems: "center",
  },

  icon: {
    marginRight: "6px",
    height: "15px",
    width: "15px",
  },

  linkBtn: {
    color: "#1A65FF",
    fontSize: "15px",
    fontWeight: "bold",
    width: "unset",
    height: "unset",
    minHeight: "unset",
    padding: 0,
    "&:hover": {
      textDecoration: "underline",
      backgroundColor: "none !important",
    },
  },

  senderItem: {
    width: "100%",
    height: "100px",
    borderRadius: "2px",
    border: "1px solid #D8DBDF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 25px",
    marginBottom: "18px",
    boxSizing: "border-box",
  },

  senderItemLeft: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
  },

  mailItem: {
    marginBottom: "4px",
  },

  iconBtn: {
    border: "1px solid #D8DBDF",
    marginLeft: "10px",
    fontSize: "15px",
    height: "38px",
    boxSizing: "border-box",
    minWidth: "unset",
    padding: 0,
  },

  space: {
    marginRight: "10px",
  },

  formControlLabel: {
    margin: "-5px",
  },

  flex: {
    flex: 1,
  },
});

const tagStatus = {
  no_tracking: "解析タグは設置されていない、もしくは、確認中です。",
  ok: "解析タグは正常に動作しています。",
  ng: "解析タグが正しく設置されていません。",
};

class BasicPanel extends React.Component {
  state = {
    showChangePasswordDialog: false,
    showChangeSecurityQuestionDialog: false,
    showEditEmailDialog: false,
    showEditNameDialog: false,
    showDeleteAccountDialog: false,
    showDeleteChildAccountDialog: false,
    showCreateSenderDialog: false,
    showEditSenderDialog: false,
    showConfirmDeleteDialog: false,
    showCreateOrderContactDialog: false,
    showEditOrderContactDialog: false,
    showConfirmDeleteOrderContactDialog: false,
    showCreateMailDialog: false,
    showEditMailDialog: false,
    showEditMailsDialog: false,
    showConfirmDeleteMailDialog: false,
    showEditAuthorityDialog: false,
    showProxyLoginChildAccountDialog: false,
    selectedSender: null,
    item: null,
    editAuthorityTitle: null,
    editAuthorityType: null,
  };

  toggleEditNameDialog = () => {
    this.setState({ showEditNameDialog: !this.state.showEditNameDialog });
  };

  toggleEditEmailDialog = () => {
    this.setState({ showEditEmailDialog: !this.state.showEditEmailDialog });
  };

  toggleChangePasswordDialog = () => {
    this.setState({
      showChangePasswordDialog: !this.state.showChangePasswordDialog,
    });
  };

  toggleChangeSecurityQuestionDialog = () => {
    this.setState({
      showChangeSecurityQuestionDialog:
        !this.state.showChangeSecurityQuestionDialog,
    });
  };

  toggleCreateOrderContactDialog = () => {
    this.setState({
      showCreateOrderContactDialog: !this.state.showCreateOrderContactDialog,
    });
  };

  toggleEditAuthorityDialog = (title = null, type = null) => {
    this.setState({
      showEditAuthorityDialog: !this.state.showEditAuthorityDialog,
      editAuthorityTitle: title,
      editAuthorityType: type,
    });
  }

  accountInfo = [
    {
      title: "名前",
      key: "name",
      button: "編集",
      handler: this.toggleEditNameDialog,
    },
    {
      title: "メールアドレス",
      key: "email",
      button: "編集",
      handler: this.toggleEditEmailDialog,
    },
    {
      title: "パスワード",
      key: "password",
      button: "変更",
      handler: this.toggleChangePasswordDialog,
    },
    {
      title: "セキュリティの質問",
      key: "security_question",
      button: "変更",
      handler: this.toggleChangeSecurityQuestionDialog,
    },
  ];

  authorityInfo = [
    {
      title: "注文履歴",
      key: "letter-order",
    },
    {
      title: "ダウンロード履歴",
      key: "download-history",
    },
    {
      title: "キーマンデータベース",
      key: "executive-list",
    },
    {
      title: "自社リスト",
      key: "house-list",
    },
    {
      title: "タイムライン",
      key: "timeline",
    },
  ];

  toggleDeleteAccountDialog = () => {
    this.setState({
      showDeleteAccountDialog: !this.state.showDeleteAccountDialog,
    });
  };

  toggleDeleteChildAccountDialog = () => {
    this.setState({
      showDeleteChildAccountDialog: !this.state.showDeleteChildAccountDialog,
    });
  };

  toggleProxyLoginChildAccountDialog = () => {
    this.setState({
      showProxyLoginChildAccountDialog: !this.state.showProxyLoginChildAccountDialog,
    });
  };


  toggleCreateSenderDialog = () => {
    this.setState({
      showCreateSenderDialog: !this.state.showCreateSenderDialog,
    });
  };

  toggleEditSenderDialog = (item = null) => {
    this.setState({
      showEditSenderDialog: !this.state.showEditSenderDialog,
      item: item,
    });
  };

  toggleEditOrderContactDialog = (item = null) => {
    this.setState({
      showEditOrderContactDialog: !this.state.showEditOrderContactDialog,
      item: item,
    });
  };

  toggleConfirmDeleteDialog = (sender = null) => {
    this.setState({
      showConfirmDeleteDialog: !this.state.showConfirmDeleteDialog,
      item: sender,
    });
  };

  toggleConfirmDeleteOrderContactDialog = (contact = null) => {
    this.setState({
      showConfirmDeleteOrderContactDialog:
        !this.state.showConfirmDeleteOrderContactDialog,
      item: contact,
    });
  };

  toggleCreateMailDialog = () => {
    this.setState({
      showEditMailsDialog: false,
      showCreateMailDialog: !this.state.showCreateMailDialog,
    });
  };

  toggleEditMailDialog = (mail = null) => {
    this.setState({
      showEditMailsDialog: false,
      showEditMailDialog: !this.state.showEditMailDialog,
      item: mail,
    });
  };

  toggleEditMailsDialog = () => {
    this.setState({
      showEditMailsDialog: !this.state.showEditMailsDialog,
    });
  };

  toggleConfirmDeleteMailDialog = (mail = null) => {
    this.setState({
      showEditMailsDialog: false,
      showConfirmDeleteMailDialog: !this.state.showConfirmDeleteMailDialog,
      item: mail,
    });
  };

  handleSave = (userInfo) => {
    if (!this.props.isChildEdit) {
      this.props.setUserInfo(userInfo);
    } else {
      this.props.patchChildUserAuthorityById(this.props.childUser.id, userInfo)
    }
  };

  handleToggleEmailNotificationFlag = (e) => {
    this.props.setUserInfo({
      email_notification_flag: e.target.checked ? 1 : 0,
    });
  };

  handleToggleNewExeEmailNotifFlag = (e) => {
    this.props.setUserInfo({
      new_exe_email_notif_flag: e.target.checked ? 1 : 0,
    });
  };

  handleToggleUpdateOrderStatusEmailNotifFlag = (e) => {
    this.props.setUserInfo({
      update_order_status_email_notif_flag: e.target.checked ? 1 : 0,
    });
  };

  handleToggleFollowCallEmailNotifFlag = (e) => {
    this.props.setUserInfo({
      follow_call_email_notif_flag: e.target.checked ? 1 : 0,
    });
  };

  handleToggleRecommendKeymanEmailNotifFlag = (e) => {
    this.props.setUserInfo({
      recommend_keyman_email_notif_flag: e.target.checked ? 1 : 0,
    });
  };

  handleDeleteSender = (id) => () => {
    this.props.deleteSender(id);
  };

  handleDeleteOrderContact = (id) => () => {
    this.props.deleteOrderContacts(id);
  };

  handleDeleteMail = (id) => () => {
    this.props.deleteUserMailsById(id);
  };

  /******** Rendering functions *********/

  renderAccountTable = () => {
    const { classes } = this.props;
    let user;
    if (this.props.isChildEdit) {
      user = this.props.childUser ? this.props.childUser : {};
    } else {
      user = this.props.user ? this.props.user : {};
    }

    return (
      <div>
        <SectionHead className={classes.sectionHeader} title="アカウント情報" />
        <Table className={classes.table}>
          <TableBody>
            {this.accountInfo.map((item, i) => {
              return this.renderAccountRow(
                i,
                item.title,
                item.key === "password" ? "********" : user[item.key],
                item.button,
                item.handler,
                'account',
              );
            })}
          </TableBody>
        </Table>
      </div>
    );
  };

  renderAuthorityTable = () => {
    const { classes, user } = this.props;
    let childUser = this.props.childUser ? this.props.childUser : {};
    return (
      <div>
        <SectionHead className={classes.sectionHeader} title="権限の設定" />
        <Table className={classes.table}>
          <TableBody>
            {this.authorityInfo.filter(item => item.key !== "download-history" || hasEverBeenEnabledExportPlan(user)).map((item, i) => {
              let text;
              if (childUser && childUser.user_role) {
                if (item.key === "letter-order") {
                  text = !childUser.user_role[item.key]['read'] ? ChildAccountLetterOrderAuthorityValue.UNACCESSIBLE.text : ChildAccountLetterOrderAuthorityValue.READ.text;
                } else if (item.key === "download-history") {
                  // 権限の保存データがない子アカウントはアクセス不可として表示する
                  const downloadHistoryRole = childUser.user_role[item.key];
                  text = downloadHistoryRole && downloadHistoryRole['read'] ? ChildAccountDownloadHistoryAuthorityValue.READ.text : ChildAccountDownloadHistoryAuthorityValue.UNACCESSIBLE.text;
                } else if (item.key === "timeline") {
                  text = childUser.user_role[item.key]['edit'] ? ChildAccountTimelineAuthorityValue.EDIT.text :
                    childUser.user_role[item.key]['read'] ? ChildAccountTimelineAuthorityValue.READ.text :
                      ChildAccountTimelineAuthorityValue.UNACCESSIBLE.text;
                } else if (item.key === "house-list") {
                  text = !!childUser.user_role[item.key]['edit'] ||
                    !!childUser.user_role[item.key]['edit-tag'] ||
                    !!childUser.user_role[item.key]['order-letter'] ||
                    !!childUser.user_role[item.key]['download-list'] ?
                    ChildAccountAuthorityValue.EDIT.text :
                    childUser.user_role[item.key]['read'] ?
                      ChildAccountAuthorityValue.READ.text :
                      ChildAccountAuthorityValue.UNACCESSIBLE.text;
                  if (text === '編集') {
                    text += '（'
                    text += childUser.user_role[item.key]['order-letter'] ? 'レター送付・' : '';
                    text += childUser.user_role[item.key]['edit'] ? 'アドレスの追加 / 編集・' : '';
                    text += childUser.user_role[item.key]['edit-tag'] ? 'リストの追加 / 編集・' : '';
                    text += childUser.user_role[item.key]['download-list'] ? 'キーマンリストDL・' : '';
                    text = text.slice(0, -1)
                    text += '）'
                  }
                } else if (item.key === "executive-list") {
                  text = !!childUser.user_role[item.key]['edit-tag'] ||
                    !!childUser.user_role[item.key]['order-letter'] ||
                    !!childUser.user_role[item.key]['download-list'] ||
                    !!childUser.user_role[item.key]['download-letter-ordered-list'] ?
                    ChildAccountAuthorityValue.EDIT.text :
                    childUser.user_role[item.key]['read'] ?
                      ChildAccountAuthorityValue.READ.text :
                      ChildAccountAuthorityValue.UNACCESSIBLE.text;
                  if (text === '編集') {
                    text += '（'
                    text += (isEnabledSendLetter(user) && childUser.user_role[item.key]['order-letter']) ? 'レター送付・' : '';
                    text += childUser.user_role[item.key]['edit-tag'] ? 'リストの追加 / 編集・' : '';
                    text += (isEnabledExportExecutiveList(user) && childUser.user_role[item.key]['download-list']) ? 'キーマンリストDL・' : '';
                    text += (isEnabledSendLetter(user) && childUser.user_role[item.key]['download-letter-ordered-list']) ? '注文済みキーマンDL・' : '';
                    text = text.slice(0, -1)
                    text += '）'
                  }
                }
              }
              return this.renderAccountRow(
                i,
                item.title,
                text,
                '編集',
                () => this.toggleEditAuthorityDialog(item.title, item.key),
                'authority',
              );
            })}
          </TableBody>
        </Table>
      </div>
    );
  };

  renderOrderContactSection = () => {
    const { classes, orderContacts, isLoadingOrderContacts } = this.props;
    return (
      <div>
        <SectionHead className={classes.sectionHeader}>
          <div className={classes.sectionHeaderInner}>
            <Typography variant="subheading" style={{ fontWeight: "bold" }}>
              注文担当者
            </Typography>
          </div>
        </SectionHead>

        <div>
          {(() => {
            if (!isLoadingOrderContacts) {
              if (orderContacts.length === 0) {
                return (
                  <div className={classes.sendersContainer}>
                    <div className={classes.row} style={{ marginTop: "30px" }}>
                      <Typography
                        variant="subheading"
                        style={{ marginRight: "10px" }}
                      >
                        注文担当者が登録されていません。
                      </Typography>
                      <Button
                        variant="flat"
                        color="primary"
                        className={classes.linkBtn}
                        onClick={this.toggleCreateOrderContactDialog}
                      >
                        注文担当者を追加
                      </Button>
                    </div>
                  </div>
                );
              } else {
                return (
                  <div className={classes.sendersContainer}>
                    {orderContacts.map((contact, i) =>
                      this.renderOrderContactItem(contact, i)
                    )}
                    <Button
                      className={classes.linkBtn}
                      onClick={this.toggleCreateOrderContactDialog}
                    >
                      注文担当者を追加
                    </Button>
                  </div>
                );
              }
            }
          })()}
        </div>
      </div>
    );
  };

  renderOrderContactItem = (contact, index) => {
    const { classes } = this.props;

    return (
      <div key={index} className={classes.senderItem}>
        <div className={classes.senderItemLeft}>
          <Typography variant="subheading" style={{ fontWeight: "bold" }}>
            {contact.name}
          </Typography>
        </div>
        <div className={classes.senderItemRight}>
          <Button
            className={classes.iconBtn}
            onClick={() => this.toggleConfirmDeleteOrderContactDialog(contact)}
            style={{ width: "38px" }}
          >
            <Trash height={16} width={16} color="#181819" />
          </Button>
          <Button
            className={classes.iconBtn}
            onClick={() => this.toggleEditOrderContactDialog(contact)}
            style={{ width: "70px" }}
          >
            編集
          </Button>
        </div>
      </div>
    );
  };

  renderSenderSection = () => {
    const { classes, senders, isLoadingSenders } = this.props;
    return (
      <div>
        <SectionHead className={classes.sectionHeader}>
          <div className={classes.sectionHeaderInner}>
            <Typography variant="subheading" style={{ fontWeight: "bold" }}>
              差出人
            </Typography>
            <ArrowToolTip text="レターの封筒裏面に記載する差出人情報を設定します">
              <HelpIcon
                width={16}
                height={16}
                color="#71737B"
                style={{ marginLeft: "8px", marginTop: "-2px" }}
              />
            </ArrowToolTip>
          </div>
        </SectionHead>

        <div>
          {(() => {
            if (!isLoadingSenders) {
              if (senders.length === 0) {
                return (
                  <div className={classes.sendersContainer}>
                    <div className={classes.row} style={{ marginTop: "30px" }}>
                      <Typography
                        variant="subheading"
                        style={{ marginRight: "10px" }}
                      >
                        差出人が登録されていません。
                      </Typography>
                      <Button
                        variant="flat"
                        color="primary"
                        className={classes.linkBtn}
                        onClick={this.toggleCreateSenderDialog}
                      >
                        差出人を追加
                      </Button>
                    </div>
                  </div>
                );
              } else {
                return (
                  <div className={classes.sendersContainer}>
                    {senders.map((sender, i) =>
                      this.renderSenderItem(sender, i)
                    )}
                    <Button
                      className={classes.linkBtn}
                      onClick={this.toggleCreateSenderDialog}
                    >
                      差出人を追加
                    </Button>
                  </div>
                );
              }
            }
          })()}
        </div>
      </div>
    );
  };

  renderSenderItem = (sender, index) => {
    const { classes, user } = this.props;

    return (
      <div key={index} className={classes.senderItem}>
        <div className={classes.senderItemLeft}>
          <Typography variant="subheading" style={{ fontWeight: "bold" }}>
            {sender.company ? (
              <span className={classes.space}>{sender.company}</span>
            ) : (
              ""
            )}
            {sender.branch ? (
              <span className={classes.space}>{sender.branch}</span>
            ) : (
              ""
            )}
            {sender.position ? (
              <span className={classes.space}>{sender.position}</span>
            ) : (
              ""
            )}
            {sender.name ? <span>{sender.name}</span> : ""}
          </Typography>
          {(!!sender["address"] || !!sender["post_code"]) && (
            <Typography variant="body2" style={{ color: "#71737B" }}>
              {`${sender["post_code"]
                  ? formatPostcode(sender["post_code"]) + " "
                  : ""
                }${sender["address"] ? sender["address"] : ""}`}
            </Typography>
          )}
          <OwnerShipLabel name={sender.ownership_user_name} />
        </div>
        {(user && user.id === sender.ownership_user_id) && (
          <div className={classes.senderItemRight}>
            <Button
              className={classes.iconBtn}
              onClick={() => this.toggleConfirmDeleteDialog(sender)}
              style={{ width: "38px" }}
            >
              <Trash height={16} width={16} color="#181819" />
            </Button>
            <Button
              className={classes.iconBtn}
              onClick={() => this.toggleEditSenderDialog(sender)}
              style={{ width: "70px" }}
            >
              編集
            </Button>
          </div>
        )}
      </div>
    );
  };

  renderAccountRow = (i, title, value, button, onClickHandler, type) => {
    const { classes, isChildEdit, user } = this.props;
    // 子アカウント設定または子アカウントユーザのアカウント情報にはセキュリティの質問は表示しない
    if ((!!isChildEdit && title === 'セキュリティの質問') || (user && !!user.user_role && title === 'セキュリティの質問')) {
      return;
    }
    return (
      <TableRow className={classes.tableRow} key={i}>
        <TableCell className={classNames(classes.tableCell, classes.firstCol)}>
          {title}
        </TableCell>
        <TableCell className={classNames(classes.tableCell, classes.secondCol)}>
          {value}
        </TableCell>
        <TableCell className={classNames(classes.tableCell, classes.thirdCol)}>
          <Button
            color="primary"
            className={classNames(classes.button, classes.rightAlign)}
            onClick={type === 'account' ? onClickHandler : onClickHandler}
            style={{ display: user && !!user.user_role ? 'none' : 'block' }} //子アカウントユーザは編集ボタンを表示しない
          >
            {button}
          </Button>
        </TableCell>
      </TableRow>
    );
  };

  renderMailSettingSection = () => {
    const { classes, isLoadingMails, mails, user } = this.props;

    let showExeNotif = user ? !!user.new_exe_notif_flag : false;
    let showReactionMailSetting = true;
    // 子アカウントはレター送付権限がある場合のみ「QRコードにリアクションがある度通知メールを受け取る」を表示
    if ((user && user.user_role && user.user_role['house-list']['order-letter'] === false) &&
      (user && user.user_role && user.user_role['executive-list']['order-letter'] === false)) {
      showReactionMailSetting = false;
    }

    let showNewExeMailSetting = true;
    // 子アカウントはキーマンデータベース権限がある場合のみ「新規キーマンに関する通知メールを受け取る」を表示
    if ((user && user.user_role && user.user_role['executive-list']['read'] === false)) {
      showNewExeMailSetting = false;
    }

    let showUpdateOrderStatusMailSetting = true;
    // 子アカウントは送付権限がある場合のみ「注文ステータスに更新がある度通知メールを受け取る」を表示
    if (user && user.user_role) {
      showUpdateOrderStatusMailSetting = false;
      if (user.user_role['executive-list']['order-letter'] === true || user.user_role['house-list']['order-letter'] === true) {
        showUpdateOrderStatusMailSetting = true;
      }
    }

    let showFollowCallMailSetting = false;
    if (isKLFollowCall(user)) {
      showFollowCallMailSetting = true;
      // 子アカウントは送付権限がある場合のみ「フォローコールで資料送付または商談獲得になった場合に通知メールを受け取る」を表示
      if (
        (user && user.user_role && user.user_role['house-list']['order-letter'] === false) &&
        (user && user.user_role && user.user_role['executive-list']['order-letter'] === false)
      ) {
        showFollowCallMailSetting = false;
      }
    }

    let message =
      "Eメールを設定すると、QRコードにリアクションがある度に、通知メールを受け取ることができます。";

    if (showExeNotif) {
      message =
        "Eメールを設定すると、QRコードにリアクションがあったり、新規キーマンが追加された時に、通知メールを受け取ることができます。";
    }

    // 子アカウントユーザの場合レター送付権限がない、キーマンデータベースに閲覧権限がない場合はメール通知設定を表示しない
    if (user && user.user_role && !showReactionMailSetting && !showNewExeMailSetting && !showUpdateOrderStatusMailSetting && !showFollowCallMailSetting) {
      return;
    } else {
      return (
        <div>
          <SectionHead className={classes.sectionHeader}>
            <div className={classes.sectionHeaderInner}>
              <Typography variant="subheading" style={{ fontWeight: "bold" }}>
                メール通知設定
              </Typography>
              <ArrowToolTip text={message}>
                <HelpIcon
                  width={16}
                  height={16}
                  color="#71737B"
                  style={{ marginLeft: "8px", marginTop: "-2px" }}
                />
              </ArrowToolTip>
              <div className={classes.flex}></div>
            </div>
          </SectionHead>

          <Table className={classes.table}>
            <TableBody>
              <TableRow className={classes.tableRow}>
                <TableCell
                  className={classNames(classes.tableCell, classes.mailFirstCol)}
                >
                  メールアドレス
                </TableCell>
                <TableCell
                  className={classNames(classes.tableCell, classes.mailSecondCol)}
                >
                  {(() => {
                    if (!isLoadingMails) {
                      if (mails.length === 0) {
                        return "通知用メールアドレスが設定されてません。";
                      } else {
                        return (
                          <div>
                            {mails.map((mail, i) => (
                              <div key={i} className={classes.mailItem}>
                                {`${mail.email} (${mail.name}) ${i === mails.length - 1 ? "" : ","
                                  }`}
                              </div>
                            ))}
                          </div>
                        );
                      }
                    }
                  })()}
                </TableCell>
                <TableCell
                  className={classNames(classes.tableCell, classes.mailThirdCol)}
                >
                  {!isLoadingMails && (
                    <Button
                      color="primary"
                      className={classNames(classes.button, classes.rightAlign)}
                      onClick={this.toggleEditMailsDialog}
                    >
                      編集
                    </Button>
                  )}
                </TableCell>
              </TableRow>
              {(mails.length > 0) && (
                <React.Fragment>
                  {showReactionMailSetting && (
                    <TableRow className={classes.tableRow}>
                      <TableCell
                        className={classNames(classes.tableCell, classes.mailFirstCol)}
                      >
                        QRコードにリアクションがある度通知メールを受け取る
                      </TableCell>
                      <TableCell
                        className={classNames(classes.tableCell, classes.mailSecondCol)}
                      ></TableCell>
                      <TableCell
                        className={classNames(classes.tableCell, classes.mailThirdCol)}
                      >
                        <FormControlLabel
                          control={
                            <Switch
                              checked={!!user && !!user.email_notification_flag}
                              onChange={this.handleToggleEmailNotificationFlag}
                              value="toggle_user_mail_setting"
                              color="primary"
                            />
                          }
                          className={classNames(
                            classes.formControlLabel,
                            classes.rightAlign
                          )}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                  {showExeNotif && showNewExeMailSetting && (
                    <TableRow className={classes.tableRow}>
                      <TableCell
                        className={classNames(
                          classes.tableCell,
                          classes.mailFirstCol
                        )}
                      >
                        新規キーマンに関する通知メールを受け取る
                      </TableCell>
                      <TableCell
                        className={classNames(
                          classes.tableCell,
                          classes.mailSecondCol
                        )}
                      ></TableCell>
                      <TableCell
                        className={classNames(
                          classes.tableCell,
                          classes.mailThirdCol
                        )}
                      >
                        <FormControlLabel
                          control={
                            <Switch
                              checked={!!user && !!user.new_exe_email_notif_flag}
                              onChange={this.handleToggleNewExeEmailNotifFlag}
                              value="toggle_user_new_exe_email_notif_flag"
                              color="primary"
                            />
                          }
                          className={classNames(
                            classes.formControlLabel,
                            classes.rightAlign
                          )}
                        />
                      </TableCell>
                    </TableRow>
                  )}

                  {showUpdateOrderStatusMailSetting && (
                    <TableRow className={classes.tableRow}>
                      <TableCell
                        className={classNames(classes.tableCell, classes.mailFirstCol)}
                      >
                        注文ステータスに更新がある度通知メールを受け取る
                      </TableCell>
                      <TableCell
                        className={classNames(classes.tableCell, classes.mailSecondCol)}
                      ></TableCell>
                      <TableCell
                        className={classNames(classes.tableCell, classes.mailThirdCol)}
                      >
                        <FormControlLabel
                          control={
                            <Switch
                              checked={!!user && !!user.update_order_status_email_notif_flag}
                              onChange={this.handleToggleUpdateOrderStatusEmailNotifFlag}
                              value="toggle_user_update_order_status_email_notif_flag"
                              color="primary"
                            />
                          }
                          className={classNames(
                            classes.formControlLabel,
                            classes.rightAlign
                          )}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                  {showFollowCallMailSetting && (
                    <TableRow className={classes.tableRow}>
                      <TableCell
                        className={classNames(classes.tableCell, classes.mailFirstCol)}
                      >
                        フォローコールで資料送付または商談獲得になった場合に通知メールを受け取る
                      </TableCell>
                      <TableCell
                        className={classNames(classes.tableCell, classes.mailSecondCol)}
                      ></TableCell>
                      <TableCell
                        className={classNames(classes.tableCell, classes.mailThirdCol)}
                      >
                        <FormControlLabel
                          control={
                            <Switch
                              checked={!!user && !!user.follow_call_email_notif_flag}
                              onChange={this.handleToggleFollowCallEmailNotifFlag}
                              value="toggle_user_follow_call_email_notif_flag"
                              color="primary"
                            />
                          }
                          className={classNames(
                            classes.formControlLabel,
                            classes.rightAlign
                          )}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              )}

            </TableBody>
          </Table>
        </div>
      );
    }
  };

  // おすすめ情報のお知らせ（サービスからのご案内メール）設定セクション
  // 業務通知とは異なり、ログイン用メールアドレス宛に送信される販促／ご案内メールのため、
  // 通知用メールアドレス（mails）の登録有無に依存せず表示する
  renderRecommendInfoSection = () => {
    const { classes, user } = this.props;

    return (
      <div>
        <SectionHead className={classes.sectionHeader}>
          <div className={classes.sectionHeaderInner}>
            <Typography variant="subheading" style={{ fontWeight: "bold" }}>
              おすすめ情報のお知らせ
            </Typography>
            <ArrowToolTip text="おすすめのキーマンなど、サービスからのご案内メールの配信設定です。ログイン用のメールアドレス宛に送信されます。">
              <HelpIcon
                width={16}
                height={16}
                color="#71737B"
                style={{ marginLeft: "8px", marginTop: "-2px" }}
              />
            </ArrowToolTip>
            <div className={classes.flex}></div>
          </div>
        </SectionHead>

        <Table className={classes.table}>
          <TableBody>
            <TableRow className={classes.tableRow}>
              <TableCell
                className={classNames(classes.tableCell, classes.mailFirstCol)}
              >
                おすすめのキーマンのご案内メールを受け取る
              </TableCell>
              <TableCell
                className={classNames(classes.tableCell, classes.mailSecondCol)}
              ></TableCell>
              <TableCell
                className={classNames(classes.tableCell, classes.mailThirdCol)}
              >
                <FormControlLabel
                  control={
                    <Switch
                      checked={!!user && !!user.recommend_keyman_email_notif_flag}
                      onChange={this.handleToggleRecommendKeymanEmailNotifFlag}
                      value="toggle_user_recommend_keyman_email_notif_flag"
                      color="primary"
                    />
                  }
                  className={classNames(
                    classes.formControlLabel,
                    classes.rightAlign
                  )}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    );
  };

  renderNoTracking = () => {
    const { classes } = this.props;

    return (
      <div className={classes.row}>
        <Exclamation
          color="#71737B"
          width={15}
          height={15}
          className={classes.icon}
        />
        <Typography variant="body1">{tagStatus.no_tracking}</Typography>
      </div>
    );
  };

  renderOk = () => {
    const { classes } = this.props;

    return (
      <div className={classes.row}>
        <CheckCircle
          color="#33F084"
          width={15}
          height={15}
          className={classes.icon}
        />
        <Typography variant="body1">{tagStatus.ok}</Typography>
      </div>
    );
  };

  renderNg = () => {
    const { classes } = this.props;

    return (
      <div className={classes.row}>
        <CancelCircle
          color="#F03A47"
          width={15}
          height={15}
          className={classes.icon}
        />
        <Typography variant="body1">{tagStatus.ng}</Typography>
      </div>
    );
  };

  renderTagStatus = () => {
    let user = this.props.user ? this.props.user : {};
    let status = TagValidStatus.NO_TRACKING;

    if (user && user.tag) status = user.tag.valid_status;

    switch (status) {
      case TagValidStatus.NO_TRACKING:
        return this.renderNoTracking();
      case TagValidStatus.OK:
        return this.renderOk();
      case TagValidStatus.NG:
        return this.renderNg();
      default:
        return this.renderNoTracking();
    }
  };

  renderProxyLogin = () => {
    const { classes, childUser } = this.props;

    return (
      <div>
        <SectionHead title='代理ログインする' />
        <div style={{ marginTop: "24px" }}>
          <Button
            color="primary"
            className={classes.button}
            onClick={this.toggleProxyLoginChildAccountDialog}
          >
            {childUser && childUser.name ? `${childUser.name}として` : ''}代理ログインする
          </Button>
        </div>
      </div>
    );
  };

  renderDeleteAccount = () => {
    const { classes } = this.props;

    return (
      <div>
        <SectionHead title="アカウントを削除" />
        <div style={{ marginTop: "24px" }}>
          <Button
            color="secondary"
            className={classNames(classes.button, classes.buttonDelete)}
            onClick={!this.props.isChildEdit ? this.toggleDeleteAccountDialog : this.toggleDeleteChildAccountDialog}
          >
            アカウントを削除
          </Button>
        </div>
      </div>
    );
  };

  /******** Render Dialogs *********/
  renderEditNameDialog = () => {
    let user = this.props.user ? this.props.user : {};
    let childUser = this.props.childUser ? this.props.childUser : {};

    return (
      <EditEntryDialog
        title="名前を編集"
        toggleDialog={this.toggleEditNameDialog}
        isOpen={this.state.showEditNameDialog}
        value={!this.props.isChildEdit ? user.name : childUser.name}
        save={this.handleSave}
        type="name"
        isSaving={this.props.isSaving}
        error={this.props.error}
      />
    );
  };

  renderEditEmailDialog = () => {
    let user = this.props.user ? this.props.user : {};
    let childUser = this.props.childUser ? this.props.childUser : {};

    return (
      <EditEntryDialog
        title="メールアドレスを編集"
        toggleDialog={this.toggleEditEmailDialog}
        isOpen={this.state.showEditEmailDialog}
        value={!this.props.isChildEdit ? user.email : childUser.email}
        save={this.handleSave}
        type="email"
        isSaving={this.props.isSaving}
        error={this.props.error}
      />
    );
  };

  renderCreateSenderDialog = () => {
    if (this.state.showCreateSenderDialog) {
      return (
        <EditSenderDialog
          type={DialogType.CREATE}
          toggleDialog={this.toggleCreateSenderDialog}
          isOpen={this.state.showCreateSenderDialog}
          save={this.props.postSender}
          isSaving={this.props.isSaving}
          error={this.props.error}
        />
      );
    }
  };

  renderEditSenderDialog = () => {
    if (this.state.showEditSenderDialog) {
      return (
        <EditSenderDialog
          type={DialogType.EDIT}
          toggleDialog={this.toggleEditSenderDialog}
          isOpen={this.state.showEditSenderDialog}
          item={this.state.item}
          save={this.props.postSender}
          isSaving={this.props.isSaving}
          error={this.props.error}
        />
      );
    }
  };

  renderConfirmDeleteDialog = () => {
    if (this.state.showConfirmDeleteDialog) {
      return (
        <ConfirmDeleteDialog
          toggleDialog={this.toggleConfirmDeleteDialog}
          isOpen={this.state.showConfirmDeleteDialog}
          action={this.handleDeleteSender(this.state.item.id)}
          isLoading={this.props.isDeleting}
          name={formatNameWithPosition(this.state.item)}
          itemName="差出人"
          buttonText="OK"
        />
      );
    }
  };

  renderConfirmDeleteOrderContactDialog = () => {
    if (this.state.showConfirmDeleteOrderContactDialog) {
      return (
        <ConfirmDeleteDialog
          toggleDialog={this.toggleConfirmDeleteOrderContactDialog}
          isOpen={this.state.showConfirmDeleteOrderContactDialog}
          action={this.handleDeleteOrderContact(this.state.item.id)}
          isLoading={this.props.isDeleting}
          name={formatNameWithPosition(this.state.item)}
          itemName="注文担当者"
          buttonText="OK"
        />
      );
    }
  };

  renderConfirmDeleteMailDialog = () => {
    if (this.state.showConfirmDeleteMailDialog) {
      return (
        <ConfirmDeleteDialog
          toggleDialog={this.toggleConfirmDeleteMailDialog}
          isOpen={this.state.showConfirmDeleteMailDialog}
          action={this.handleDeleteMail(this.state.item.id)}
          isLoading={this.props.isDeleting}
          name={this.state.item.email}
          itemName="メールアドレス"
          buttonText="OK"
        />
      );
    }
  };

  renderChangePasswordDialog = () => {
    return (
      <ChangePasswordDialog
        toggleDialog={this.toggleChangePasswordDialog}
        isOpen={this.state.showChangePasswordDialog}
        postUsersUpdatePassword={this.props.postUsersUpdatePassword}
        childUserSave={this.props.patchChildUserAuthorityById}
        isSaving={this.props.isSaving}
        error={this.props.error}
        user={this.props.user}
        isChildEdit={this.props.isChildEdit}
        childUser={this.props.childUser}
      />
    );
  };

  renderChangeSecurityQuestionDialog = () => {
    return (
      <ChangeSecurityQuestionDialog
        toggleDialog={this.toggleChangeSecurityQuestionDialog}
        isOpen={this.state.showChangeSecurityQuestionDialog}
        postUsersUpdatePassword={this.props.postUsersUpdatePassword}
        isSaving={this.props.isSaving}
        error={this.props.error}
        user={this.props.user}
      />
    );
  };

  renderDeleteAccountDialog = () => {
    return (
      <DeleteAccountDialog
        isOpen={this.state.showDeleteAccountDialog}
        toggleDialog={this.toggleDeleteAccountDialog}
        delete={this.props.deleteAccount}
      />
    );
  };

  renderProxyLoginChildAccountDialog = () => {
    const { childUser, isProxyLoginLoading } = this.props;
    return (
      <ChildAccountConfirmDialog
        isOpen={this.state.showProxyLoginChildAccountDialog}
        toggleDialog={this.toggleProxyLoginChildAccountDialog}
        title={childUser && childUser.name ? `${childUser.name}として代理ログインする` : '代理ログインする'}
        childUser={childUser}
        type={'proxy_login'}
        func={this.props.proxyLoginChildUser}
        isProcessing={isProxyLoginLoading}
      />
    );
  };

  renderDeleteChildAccountDialog = () => {
    const { childUser, isDeletingChildUser } = this.props;
    return (
      <ChildAccountConfirmDialog
        isOpen={this.state.showDeleteChildAccountDialog}
        toggleDialog={this.toggleDeleteChildAccountDialog}
        type='delete'
        title='このアカウントを削除'
        childUser={childUser}
        func={this.props.deleteChildAccount}
        isProcessing={isDeletingChildUser}
      />
    );
  };

  renderCreateOrderContactDialog = () => {
    if (this.state.showCreateOrderContactDialog) {
      return (
        <EditOrderContactDialog
          type={DialogType.CREATE}
          toggleDialog={this.toggleCreateOrderContactDialog}
          isOpen={this.state.showCreateOrderContactDialog}
          save={this.props.postOrderContacts}
          isSaving={this.props.isSaving}
          error={this.props.error}
        />
      );
    }
  };

  renderEditOrderContactDialog = () => {
    if (this.state.showEditOrderContactDialog) {
      return (
        <EditOrderContactDialog
          type={DialogType.EDIT}
          toggleDialog={this.toggleEditOrderContactDialog}
          isOpen={this.state.showEditOrderContactDialog}
          item={this.state.item}
          save={this.props.postOrderContacts}
          isSaving={this.props.isSaving}
          error={this.props.error}
        />
      );
    }
  };

  renderCreateMailDialog = () => {
    if (this.state.showCreateMailDialog) {
      return (
        <EditMailDialog
          type={DialogType.CREATE}
          toggleDialog={this.toggleCreateMailDialog}
          isOpen={this.state.showCreateMailDialog}
          save={this.props.postUserMails}
          isSaving={this.props.isSaving}
          error={this.props.error}
        />
      );
    }
  };

  renderEditMailDialog = () => {
    if (this.state.showEditMailDialog) {
      return (
        <EditMailDialog
          type={DialogType.EDIT}
          toggleDialog={this.toggleEditMailDialog}
          isOpen={this.state.showEditMailDialog}
          item={this.state.item}
          save={this.props.postUserMails}
          isSaving={this.props.isSaving}
          error={this.props.error}
        />
      );
    }
  };

  renderEditMailsDialog = () => {
    if (this.state.showEditMailsDialog) {
      return (
        <EditMailsDialog
          toggleDialog={this.toggleEditMailsDialog}
          isOpen={this.state.showEditMailsDialog}
          mails={this.props.mails}
          toggleEditMailDialog={this.toggleEditMailDialog}
          toggleCreateMailDialog={this.toggleCreateMailDialog}
          toggleConfirmDeleteMailDialog={this.toggleConfirmDeleteMailDialog}
        />
      );
    }
  };

  renderEditAuthorityDialog = () => {
    if (this.state.showEditAuthorityDialog) {
      return (
        <EditAuthorityDialog
          isOpen={this.state.showEditAuthorityDialog}
          toggleDialog={this.toggleEditAuthorityDialog}
          save={this.props.patchChildUserAuthorityById}
          isSaving={this.props.isSaving}
          user={this.props.user}
          childUser={this.props.childUser}
          title={this.state.editAuthorityTitle}
          authorityType={this.state.editAuthorityType}
        />
      )
    }
  }

  render() {
    const { classes, isChildEdit, user } = this.props;

    let editNameDialog,
      editEmailDialog,
      changePasswordDialog,
      changeSecurityQuestionDialog,
      editAuthorityDialog,
      deleteAccountDialog,
      deleteChildAccountDialog,
      proxyLoginChildAccountDialog;

    if (this.state.showEditNameDialog) {
      editNameDialog = this.renderEditNameDialog();
    }
    if (this.state.showEditEmailDialog) {
      editEmailDialog = this.renderEditEmailDialog();
    }
    if (this.state.showChangePasswordDialog) {
      changePasswordDialog = this.renderChangePasswordDialog();
    }

    if (this.state.showChangeSecurityQuestionDialog) {
      changeSecurityQuestionDialog = this.renderChangeSecurityQuestionDialog();
    }

    if (this.state.showDeleteAccountDialog) {
      deleteAccountDialog = this.renderDeleteAccountDialog();
    }

    if (this.state.showDeleteChildAccountDialog) {
      deleteChildAccountDialog = this.renderDeleteChildAccountDialog();
    }

    if (this.state.showProxyLoginChildAccountDialog) {
      proxyLoginChildAccountDialog = this.renderProxyLoginChildAccountDialog();
    }

    if (this.state.showEditAuthorityDialog) { editAuthorityDialog = this.renderEditAuthorityDialog(); }

    if (!!isChildEdit && (this.props.isLoadingChildUser || this.props.isProxyLoginLoading)) {
      return (
        <Loader type='color' size="large" />
      )
    } else {
      return (
        <div className={classes.container}>
          {this.renderAccountTable()}
          {!!isChildEdit && (this.renderAuthorityTable())}
          {(() => {
          // 子アカウントの設定またはレター送付権限がない子アカウントユーザは表示しない
          if (!isChildEdit &&
            !(user && user.user_role && (user.user_role['house-list']['order-letter'] === false ||
                                        user.user_role['executive-list']['order-letter'] === false))) {
            return (
              <div>
                {this.renderSenderSection()}
                {this.renderOrderContactSection()}
              </div>
            );
          }
        })()}
          {!isChildEdit && (this.renderMailSettingSection())}
          {!isChildEdit && (this.renderRecommendInfoSection())}
          {!!isChildEdit && (this.renderProxyLogin())}
          {user && !user.user_role && (this.renderDeleteAccount())}
          {this.renderCreateSenderDialog()}
          {this.renderEditSenderDialog()}
          {this.renderConfirmDeleteDialog()}
          {this.renderCreateOrderContactDialog()}
          {this.renderEditOrderContactDialog()}
          {this.renderConfirmDeleteOrderContactDialog()}
          {this.renderConfirmDeleteMailDialog()}
          {this.renderCreateMailDialog()}
          {this.renderEditMailDialog()}
          {this.renderEditMailsDialog()}
          {editNameDialog}
          {editEmailDialog}
          {changePasswordDialog}
          {deleteAccountDialog}
          {deleteChildAccountDialog}
          {changeSecurityQuestionDialog}
          {editAuthorityDialog}
          {proxyLoginChildAccountDialog}
        </div>
      );
    }
  }
}

BasicPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  childUser: PropTypes.object,
  setUserInfo: PropTypes.func.isRequired,
  deleteAccount: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
  error: PropTypes.object,
  isChildEdit: PropTypes.bool,
  patchChildUserAuthorityById: PropTypes.func,
  deleteSender: PropTypes.func,
  postSender: PropTypes.func,
  isDeleting: PropTypes.bool,
  isDeletingChildUser: PropTypes.bool,
  isLoadingChildUser: PropTypes.bool,
  postOrderContacts: PropTypes.func,
  postUserMails: PropTypes.func,
  deleteOrderContacts: PropTypes.func,
  deleteUserMailsById: PropTypes.func,
  postUsersUpdatePassword: PropTypes.func,
  orderContacts: PropTypes.array,
  mails: PropTypes.array,
  isLoadingOrderContacts: PropTypes.bool,
  isLoadingMails: PropTypes.bool,
  isProxyLoginLoading: PropTypes.bool,
  proxyLoginChildUser: PropTypes.func,
  deleteChildAccount: PropTypes.func,
  senders: PropTypes.array,
  isLoadingSenders: PropTypes.bool,
};

PropTypes.defaultValue = {
  isChildEdit: false,
}

export default withStyles(styles)(BasicPanel);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Basic/BasicPanel.jsx